import React, { useState, useEffect } from "react";
import { styled } from "@mui/material/styles";
import { Link as RouterLink } from "react-router-dom";
import { useForm } from "react-hook-form";
import queryString from "query-string";
// import { toast } from "react-toastify";
import { useToaster } from "../_components/toaster/MuiToasterProvider";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import { SaveLoader } from "@/_components";
import { userLoginSuccess } from "../_redux/actions/accountActions";
import { accountService } from "@/_services";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import LineImage from "@/_images/orLine.png";
import LineImageEs from "@/_images/oLine.png";
const componentStyles = (theme) => ({
  form: {
    width: "100%",
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  buttonIco: {
    width: 24,
    height: 24,
    marginRight: 10,
    marginTop: 7,
  },
  inputIco: {
    opacity: 0.6,
    color: "#1c355e",
  },
});
const StyledRoot = styled("div")(({ theme }) => ({
  display: "contents",
  ...Object.entries(componentStyles(theme)).reduce(
    (acc, [className, style]) => ({
      ...acc,
      [`& .${className}, &.${className}`]: style,
    }),
    {},
  ),
}));
function normalizeQueryValue(value) {
  if (Array.isArray(value)) {
    return value[0] || "";
  }

  return value || "";
}

function isTrueQueryValue(value) {
  const normalizedValue = normalizeQueryValue(value).toLowerCase();

  return normalizedValue === "true" || normalizedValue === "1";
}

function ResetPassword({ history }) {
  const TokenStatus = {
    Validating: "Validating",
    Valid: "Valid",
    Invalid: "Invalid",
  };
  const { t, i18n } = useTranslation();
  const [token, setToken] = useState(null);
  const [userID, setUserID] = useState(null);
  const [resetUsername, setResetUsername] = useState(null);
  const [resetIsPhone, setResetIsPhone] = useState(false);
  const [tokenStatus, setTokenStatus] = useState(TokenStatus.Validating);
  const [submitting, setSubmitting] = useState(false);
  const toast = useToaster();
  const [values, setValues] = useState({
    showPassword: false,
  });
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
  });
  useEffect(() => {
    let { token, userId, email, username, isPhone } = queryString.parse(
      location.search,
    );
    token = normalizeQueryValue(token);
    userId = normalizeQueryValue(userId);
    const parsedResetUsername =
      normalizeQueryValue(username) || normalizeQueryValue(email);
    // remove token from url to prevent http referer leakage
    history.replace(location.pathname);
    if (!token || !userId) {
      setTokenStatus(TokenStatus.Invalid);
      return;
    }
    //Regexs to make the token right
    token = token.replace(/\+/g, "%2b");
    token = token.replace(/\//g, "%2f");
    token = token.replace(/=/g, "%3d");
    let userID = parseInt(userId);
    setResetUsername(parsedResetUsername);
    setResetIsPhone(isTrueQueryValue(isPhone));
    if (Number.isNaN(userID)) {
      setTokenStatus(TokenStatus.Invalid);
      return;
    }
    setToken(token);
    setUserID(userID);
    setTokenStatus(TokenStatus.Valid);
  }, []);
  function getForm() {
    const onSubmit = (data) => {
      setSubmitting(true);
      const password = data.password;
      accountService
        .resetPassword(userID, token, password)
        .then((rtn) => {
          // toast.success(t("account.passwordResetSuccess"));
          const loginIdentifier = resetIsPhone
            ? resetUsername
            : rtn.email || resetUsername;
          handleLogin(loginIdentifier, password);
        })
        .catch((error) => {
          setSubmitting(false);
          toast.error(error);
        })
        .finally(() => setSubmitting(false));
    };
    const handleClickShowPassword = () => {
      setValues({
        ...values,
        showPassword: !values.showPassword,
      });
    };
    const handleMouseDownPassword = (event) => {
      event.preventDefault();
    };
    const handleLogin = (username, password) => {
      accountService
        .login(username, password, resetIsPhone)
        .then(() => {
          userLoginSuccess();
          setSubmitting(false);
          const { from } = {
            from: {
              pathname: "/dashboard",
            },
          };
          history.push(from);
        })
        .catch((error) => {
          setSubmitting(false);
          toast.error(error);
        });
    };
    return (
      <StyledRoot>
        <form className={"form"} onSubmit={handleSubmit(onSubmit)}>
          <TextField
            variant="outlined"
            margin="normal"
            fullWidth
            size="small"
            id="password"
            label={t("account.password")}
            name="password"
            autoComplete="current-password"
            type={values.showPassword ? "text" : "password"}
            error={!!errors.password}
            helperText={errors.password ? errors.password.message : ""}
            slotProps={{
              input: {
                startAdornment: (
                  <InputAdornment position="start">
                    <LockOutlinedIcon className={"inputIco"} />
                  </InputAdornment>
                ),
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleClickShowPassword}
                      onMouseDown={handleMouseDownPassword}
                      size="large"
                    >
                      {values.showPassword ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                ),
              },
              htmlInput: {
                ...register("password", {
                  required: {
                    value: true,
                    message: t("account.passwordRequired"),
                  },
                  pattern: {
                    value:
                      /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{8,24}$/,
                    message: t("account.passwordPattern"),
                  },
                }),
              },
            }}
          />
          <TextField
            variant="outlined"
            margin="normal"
            fullWidth
            size="small"
            id="confirmPassword"
            label={t("account.confirmPassword")}
            name="confirmPassword"
            autoComplete="current-password"
            type={"password"}
            error={!!errors.confirmPassword}
            helperText={
              errors.confirmPassword ? errors.confirmPassword.message : ""
            }
            slotProps={{
              input: {
                startAdornment: (
                  <InputAdornment position="start">
                    <LockOutlinedIcon className={"inputIco"} />
                  </InputAdornment>
                ),
              },
              htmlInput: {
                ...register("confirmPassword", {
                  required: {
                    value: true,
                    message: t("account.confirmPasswordRequired"),
                  },
                  validate: (value) => {
                    if (value === watch("password")) {
                      return true;
                    } else {
                      return t("account.confirmPasswordValid");
                    }
                  },
                }),
              },
            }}
          />
          <Grid
            container
            sx={{
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "column",
            }}
          >
            <Grid>
              {submitting === false ? (
                <Button
                  type="submit"
                  size="medium"
                  disabled={submitting}
                  variant="contained"
                  color="primary"
                  className={"submit"}
                  style={{
                    width: 240,
                    height: 50,
                  }}
                >
                  {t("account.resetPasswordButton")}
                </Button>
              ) : (
                <SaveLoader />
              )}
            </Grid>
            <Grid>
              {i18n?.language === "es" ? (
                <img src={LineImageEs} alt="O" />
              ) : (
                <img src={LineImage} alt="OR" />
              )}
            </Grid>
            <Grid
              style={{
                paddingBottom: 15,
              }}
            >
              <RouterLink
                to="/login"
                style={{
                  textDecoration: "none",
                }}
              >
                <Button
                  type="submit"
                  size="medium"
                  disabled={submitting}
                  variant="contained"
                  color="secondary"
                  style={{
                    width: 240,
                    height: 50,
                  }}
                >
                  {t("account.backToSignInButton")}
                </Button>
              </RouterLink>
            </Grid>
          </Grid>
        </form>
      </StyledRoot>
    );
  }
  function getBody() {
    switch (tokenStatus) {
      case TokenStatus.Valid:
        return getForm();
      case TokenStatus.Invalid:
        return (
          <StyledRoot>
            <Typography variant="h5">
              {t("account.tokenFailedPart1")}
              <RouterLink to="forgot-password">
                {t("account.tokenFailedPart2")}
              </RouterLink>
              {t("account.tokenFailedPart3")}
            </Typography>
          </StyledRoot>
        );
      case TokenStatus.Validating:
        return <div>{t("account.tokenValidation")}</div>;
    }
  }
  return (
    <StyledRoot>
      <div>
        <div className="card-body">{getBody()}</div>
      </div>
    </StyledRoot>
  );
}
ResetPassword.propTypes = {
  history: PropTypes.object,
  userLoginSuccess: PropTypes.func,
};
function mapStateToProps(state) {
  return {
    userLoginSuccess: state.userLoginSuccess,
  };
}
const mapDispatchToProps = {
  userLoginSuccess,
};
export default connect(mapStateToProps, mapDispatchToProps)(ResetPassword);
